<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        PutAway Detail Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="regrid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <!-- <vs-button color="success" type="filled" icon="add" @click="cusAdd">Add</vs-button>
      <p class="pr-4"></p>-->
      <vs-button
        color="success"
        v-if="btndis"
        type="filled"
        icon="print"
        @click="goPrint"
        >print</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="create"
        @click="toLoc"
        v-if="btndis"
        >To Location</vs-button
      >
      <p class="pr-4"></p>
      <!-- <vs-button
        color="danger"
        type="filled"
        icon="create"
        @click="toPal"
        v-if="btndis"
        >To Pallet</vs-button
      >
      <p class="pr-4"></p> -->
    </div>

    <div
      v-if="locShow"
      class="mx-auto pb-4 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
    >
      <vx-card>
        <div class="vx-row mb-2">
          <div class="vx-col w-2/5">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              label-placeholder="Locations Code"
              v-model="locationsCode"
            />
          </div>
        </div>

        <div class="inline-flex w-4/5 pb-2">
          <div class="vx-col w-3/5 pr-6">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="PutAway Number"
              v-model="putawaydetailsNumber"
              :readonly="true"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="onLocSubmit">Submit</vs-button>
          </div>
        </div>
      </vx-card>
    </div>

    <div
      v-if="cnPalShow"
      class="mx-auto pb-4 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
    >
      <vx-card>
        <div class="vx-row mb-2">
          <div class="vx-col w-2/5">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              label-placeholder="Locations Code"
              v-model="locationsCode"
            />
          </div>
        </div>

        <div class="inline-flex w-4/5 pb-2">
          <div class="vx-col w-3/5 pr-6">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="Pallets Code"
              v-model="pallets_code"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="onCnPalSubmit"
              >Confirm</vs-button
            >
          </div>
        </div>
      </vx-card>
    </div>

    <div
      v-if="palShow"
      class="mx-auto pb-4 w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."
    >
      <vx-card>
        <div class="vx-row mb-2">
          <div class="vx-col w-2/5">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-code"
              icon-no-border
              label-placeholder="Pallet Code"
              v-model="pallets_code"
            />
          </div>
        </div>

        <div class="inline-flex w-4/5 pb-2">
          <div class="vx-col w-3/5 pr-6">
            <vs-input
              class="w-full"
              icon-pack="feather"
              icon="icon-link-2"
              icon-no-border
              label-placeholder="PutAway Number"
              v-model="putawaydetailsNumber"
              :readonly="true"
            />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click="onPalSubmit">Submit</vs-button>
            <vs-button class="mr-3 mb-2" @click="onPalRemove" color="danger"
              >Remove</vs-button
            >
          </div>
        </div>
      </vx-card>
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <!-- <palldadd v-if="addshow" :key="addshow" :acstate="acstate" :recid="recid" @grid="grid"></palldadd> -->
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></aggrid>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";
// import _color from "@/assets/utils/color.js";

export default {
  data() {
    return {
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      putawaysNumber: this.$route.params.id,
      addshow: false,
      gridshow: false,
      btndis: false,
      locShow: false,
      palShow: false,
      cnPalShow: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      putawaydetailsNumber: null,
      pallets_code: null,
      locationsCode: null,
      arData: [],
      fabact: [
        // { act: "cusAdd", label: "Add" },
        { act: "onLocSubmit", label: "Put to Location" },
        { act: "onPalSubmit", label: "Put to Pallet" },
        { act: "goPrint", label: "Print" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  sockets: {
    connect() {
      this.isConnected = true;
    },
    disconnect() {
      this.isConnected = false;
    },
  },
  methods: {
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
      this.putawaydetailsNumber = val;
    },
    // goPrint() {
    //   let url = localStorage.getItem("appdb");
    //   let dbname = localStorage.getItem("dbname");
    //   window.open(
    //     url + "api/ApiPutawaysdetailsPrint/" + this.recid + "/" + dbname
    //   );
    // },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    getArray(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbordersnumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbitemnum,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.skus_code,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.edescription,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.formatnumber(item.itempck),
            fontSize: 10,
            bold: false,
            alignment: "right",
          },
          {
            text: item.reserveloc,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
        ]);

        i++;
        // console.log(i);
      });
    },
    async goPrint() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.recid,
            // from: '2022-01-11'
          };
          // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/putawaysdetails/putawaysdetailsPrint`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);

            this.getArray(response.data.putawaysDetails);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",

              footer: {
                // columns: [
                //   "Left part",
                //   { text: "Right part", alignment: "right" },
                // ],
                columns: [
                  [
                    {
                      text: "พิมพ์ ณ วันที่ " + this.cvDate(new Date()),
                      fontSize: 14,
                      alignment: "right",
                      // [left, top, right, bottom]
                      // margin: [100, -20, 0, 0],
                      margin: [0, 0, 10, 0],
                    },
                  ],
                ],
              },

              content: [
                {
                  text: "ใบสั่งการจัดเก็บสินค้าเข้าคลังสินค้า",
                  style: "title",
                  // [left, top, right, bottom]
                  margin: [0, -20, 0, 0],
                },
                {
                  text: "ใบนำเข้าสินค้าเลขที่ " + response.data.putawaysNumber,
                  style: "subtitle",
                  margin: [0, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [30, 80, 50, 150, 205, 45, 150], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {
                          text: "ลำดับ",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Item",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Product Code",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Description",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Package",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Reserve Location",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [30, 80, 50, 150, 205, 45, 150], // 525(portrait) 700(landscape)
                    // body: this.getArray(res.data.message),
                    body: this.arData,
                    // body: [[{}, {}, {}, {}, {},{}, {}, {}]],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 18,
                  bold: true,
                  alignment: "center",
                },
                subtitle: {
                  fontSize: 16,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    // cusAdd() {
    //   this.recid = 0;
    //   this.addshow = true;
    //   this.gridshow = false;
    //   this.btndis = false;
    //   this.acstate = "ADD";
    // },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.locShow = false;
      this.palShow = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    regrid() {
      // this.$router.replace("/Skus/0");
      // this.masrec = "0";
      this.masrec = this.$route.params.id;
      this.gridshow = false;
      setTimeout(() => {
        this.grid();
      }, 1000);
    },
    toLoc() {
      this.locationsCode = "";

      this.locShow = true;
      this.palShow = false;
      this.cnPalShow = false;
    },
    toPal() {
      this.pallets_code = "";

      this.locShow = false;
      this.palShow = true;
      this.cnPalShow = false;
    },
    cnPal() {
      this.pallets_code = "";
      this.locationsCode = "";

      this.cnPalShow = true;
      this.locShow = false;
      this.palShow = false;
    },
    onCnPalSubmit() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Confirm PutAway? ",
        accept: this.onCCnPalSubmit,
      });
    },
    onLocSubmit() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Confirm PutAway? ",
        accept: this.onCLocSubmit,
      });
    },
    async onCLocSubmit() {
      if (this.locationsCode) {
        // console.log(this.locationsCode);
        try {
          const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
          this.readonly = true;

          if (token) {
            const formData = {
              putawaydetailsNumber: this.putawaydetailsNumber,
              locationsCode: this.locationsCode,
              editor: String(this.userid),
            };

            const response = await axios.post(
              `${BASE_API_URL}/inbound-svc/putawaysdetails/CnPutawayLoc`,
              formData,
              {
                headers: { Authorization: "Bearer " + token.accessToken },
              }
            );
            // console.log(response.data);

            if (response.data.status != "success") {
              this.loading = false;
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "Error from Backend",
                text: response.data.message,
              });
            } else {
              if (this.$store.state.reportgrid == 0) {
                this.$store.dispatch("setReportGrid", 1);
              } else {
                this.$store.dispatch("setReportGrid", 0);
              }

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Deleted Complete",
                text: response.data.message,
              });
            }
          }
        } catch (error) {
          this.data = [];
          this.total = 0;
          this.loading = false;
          // throw error;
          alert("กรุณาเข้าระบบอีกครั้ง");
          // this.$router.replace("/pages/login/");
        }
      } else {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Submit Error",
          text: "Please Enter Location Code",
          fixed: true,
        });
      }
    },
    onPalSubmit() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Confirm To Pallet? ",
        accept: this.onCPalSubmit,
      });
    },
    onCPalSubmit() {
      if (this.pallets_code) {
        // console.log(this.locationsCode);
        const formData = {
          token: localStorage.getItem("token"),
          dbname: localStorage.getItem("dbname"),
          putawaydetailsNumber: this.putawaydetailsNumber,
          pallets_code: this.pallets_code,
        };
        axios
          .post("/ApiCnPutPal", formData)
          .then((res) => {
            if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "PutAway Error",
                text: res.data.message,
                fixed: true,
              });
            } else {
              this.$store.dispatch("setReportGrid", 1);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "PutAway Complete",
                text: res.data.message,
              });
            }
          })
          .catch((err) => {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "PutAway Error",
              text: err,
            });
          });
      } else {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Submit Error",
          text: "Please Enter Pallet Code",
          fixed: true,
        });
      }
    },
    onPalRemove() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Remove From Pallet? ",
        accept: this.onCPalRemove,
      });
    },
    onCPalRemove() {
      if (this.pallets_code) {
        // console.log(this.locationsCode);
        const formData = {
          token: localStorage.getItem("token"),
          dbname: localStorage.getItem("dbname"),
          putawaydetailsNumber: this.putawaydetailsNumber,
          pallets_code: this.pallets_code,
        };
        axios
          .post("/ApiPaldDel", formData)
          .then((res) => {
            if (res.data.status == "error") {
              this.$vs.notify({
                position: "top-right",
                color: "danger",
                title: "PutAway Error",
                text: res.data.message,
                fixed: true,
              });
            } else {
              this.$store.dispatch("setReportGrid", 1);

              this.$vs.notify({
                position: "top-right",
                color: "success",
                title: "Remove Complete",
                text: res.data.message,
              });
            }
          })
          .catch((err) => {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "PutAway Error",
              text: err,
            });
          });
      } else {
        this.$vs.notify({
          position: "top-right",
          color: "danger",
          title: "Submit Error",
          text: "Please Enter Pallet Code",
          fixed: true,
        });
      }
    },
    // cusDel() {
    //   this.$vs.dialog({
    //     type: "confirm",
    //     color: "danger",
    //     title: `Confirm`,
    //     text: "Do you want to Delete? " + this.recid,
    //     accept: this.acceptAlert
    //   });
    // },
    // acceptAlert() {
    //   this.btndis = false;
    //   const formData = {
    //     token: localStorage.getItem("token"),
    //     code: this.recid
    //   };
    //   axios
    //     .post("/ApiDelPalletsDetail", formData)
    //     .then(res => {
    //       if (res.data.status == "error") {
    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "danger",
    //           title: "Deleted Error",
    //           text: res.data.message,
    //           fixed: true
    //         });
    //       } else {
    //         this.$store.dispatch("setPalletsDetailGrid", 1);

    //         this.$vs.notify({
    //           position: "top-right",
    //           color: "success",
    //           title: "Deleted Complete",
    //           text: res.data.message
    //         });
    //       }
    //     })
    //     .catch(err => {
    //       this.$vs.notify({
    //         position: "top-right",
    //         color: "danger",
    //         title: "Deleted Error",
    //         text: err
    //       });
    //     });

    //   // this.gridshow = false;
    //   // this.gridshow = true;
    // },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {

          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;

        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  components: {
    aggrid,
  },
    mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  created() {
    // console.log(this.inborders_number);
    this.masrec = this.putawaysNumber;
    // console.log(this.masrec);
    if (this.masrec != 0) {
      this.grid();
    }
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
